
import { NgModule } from '@angular/core';
import { OnlyNumberDirective } from './only-number.directive';
import { TwoDigitDecimaNumberDirective } from './two-digit-decimal-number.directive';

@NgModule({
  declarations: [OnlyNumberDirective, TwoDigitDecimaNumberDirective],
  exports: [OnlyNumberDirective, TwoDigitDecimaNumberDirective]
})
export class NumberAcceptModule { }
